import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
//internal and external components import
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import { Checkbox, TableRow, TextField, Tooltip } from '@mui/material/';
import { Box } from '@mui/material';
import ThreeDotMenu from '../ThreeDotMenu';
import { EnhancedTableHead } from '../EnhancedTableHead';
import TableSkeleton from '../TableSkeleton';
import { sortData } from '../../common/SortSupport';
import { faCirclePlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import CheckBox from '../CheckBox/CheckBox';
import ButtonDefault from '../ButtonDefault';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';
import { TextFieldWithoutBorders } from '../TextFieldWithoutBorders';
import DateSelector from '../DateSelector';
import { calcTaskPercentage, formatDate } from '../../common/StaticExports';
import ProgressBar from '../ProgressBar';
import CircularWithValueLabel from '../CircularProgress';

const TasksTable = (props:any) => {

  const { data, isLoading, handleChange, isReadOnly } = props;

  const threeDotMenuOptions = 
  [
    {label: 'Delete Task', icon: faTrash, isDisabled: false},
  ];
  const initialTask = {
    "id": null,
    "task": null,
    "checked": false
  }

  const [t] = useTranslation();

  //supporting contents
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('');

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: any,
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };
  
  let visibleRows = React.useMemo(
    () =>
      data && data.length > 0 &&
      sortData(data, orderBy, order),
    [order, orderBy, data],
  );

  const head = [
    {
      key: 'task', displayName: 'task',
    },
    {
      key: 'dueDate', displayName: 'due date',
    },
    {
      key: 'checked', displayName: 'complete',
    },
    {
      key: '', displayName: '',
    },
  ]

  //table contents
    return(
        <React.Fragment>
            <Box sx={{ position: 'relative', display: 'flex', justifyContent: 'space-between', width: '100%' }}  className={isReadOnly && 'cursorNotAllowed'}>
              <TableContainer 
              sx={{ 
                "& .MuiTable-root": {
                  border: 0,
                },
                "& .MuiTableCell-root": {
                  borderBottom: "none", // Remove bottom borders from table cells
                },
                "& .MuiTableRow-root": {
                  border: "none", // Remove row borders
                }
              }}>
                <Table stickyHeader size="small" aria-label="a dense table">
                    <EnhancedTableHead
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                    tableHeads={head}
                    />
                      <TableBody>
                    {
                      !isLoading && visibleRows.length ?
                      <>
                        {
                          visibleRows.map((d: any, i: number) => (
                            <>
                              <TableRow
                              className='hoverBG'
                              sx={{ cursor: 'pointer' }}
                              key={`tasks-table-row-${i}`}
                              >
                              <TableCell className='fs12' width={'900px'}>
                                <TextFieldWithoutBorders 
                                isReadOnly={isReadOnly}
                                value={d.task}
                                handleChange={(e:any) => {handleChange('task', e.target.value, i)}}
                                />
                              </TableCell>
                              <TableCell sx={{ width: '130px' }}>
                                <DateSelector variant='standard' dateValue={d?.dueDate ? formatDate(d?.dueDate) : null} 
                                manageChange={(e:any) => {
                                  const selectedDate = new Date(e);
                                  handleChange('dueDate', selectedDate, i);
                                }}
                                disabled={isReadOnly}
                                />
                              </TableCell>
                              <TableCell className='fs12'>
                                <Checkbox sx={{ padding: '0px' }} 
                                checked={d.checked} 
                                onChange={(e) => {handleChange('checked', e.target.checked, i)}}
                                disabled={isReadOnly}
                                />
                              </TableCell>
                              <TableCell className='fs12'>
                                {/* <ThreeDotMenu options={threeDotMenuOptions} manageClick={(e:any) => {}}  /> */}
                                {
                                  !isReadOnly &&
                                  <Tooltip title={t('DELETE')} arrow placement='top'>
                                    <FontAwesomeIcon className='fs14 deleteIcon' 
                                    icon={faTrashCan}
                                    onClick={() => {handleChange('deleteTask', null, i)}} />
                                  </Tooltip>
                                }
                              </TableCell>
                              </TableRow>
                            </>
                          ))
                        }
                      </>
                      :
                      (
                        !isLoading && !visibleRows ?
                          <TableRow>
                              <TableCell colSpan={head?.length - 1} className='fs12' align='center'>No Records Found</TableCell>
                          </TableRow> :
                          <TableSkeleton rowCount={4} cellCount={head?.length} />
                      )
                    }
                    </TableBody>
                </Table>
              </TableContainer>
              <Box sx={{ mt: 2, width: '20%', display: 'flex', justifyContent: 'space-between', flexDirection: 'column' }}>
                {
                  !isReadOnly &&
                  <Box sx={{ width: '120px', mb: '10px', mr: 'auto'}}>
                    <ButtonDefault
                    variant={'outlined'}
                    value={t('ADD_TASK')}
                    manageOnClick={() => {handleChange('addTask', initialTask, null)}}
                    icon={<FontAwesomeIcon className={'fs13'} icon={faCirclePlus} />}
                    />
                  </Box>
                }
                  <Box sx={{ width: 'auto' }} className={'mtbAuto'}>
                    {/* <ProgressBar percent={data ? calcTaskPercentage(data) : 0} width="100%"/> */}
                    <CircularWithValueLabel 
                    progress={data ? calcTaskPercentage(data) : 0} 
                    size={100}/>
                  </Box>
              </Box>
            </Box>
        </React.Fragment>
    )
}

export default TasksTable;